<template>
  <!-- 检索邻域 -->
  <div class="layer">
    <el-row class="header" type="flex" >
      <el-col :span="8" class="bor row" style="min-width:400px">
        <a href="javascript:;" style="text-align: center;">
          <img class="logo" src="/static/img/logo2022.png" />
        </a>
      </el-col>
    </el-row>
    <div class="retrievalFieldNew">
      <div class="center width">
        <div class="experts">
          <div class="search-form">
            <el-form ref="form" :model="form" :label-position="'left'" :class="['srarch-from-inline']" :inline="true">
              <div class="w50 pl0 ">
                <el-form-item label="论文分类号" >
                  <el-select v-model="form.CCD_NAME" remote :remote-method="filterClc" filterable  placeholder="">
                    <el-option
                    v-for="(item, index) in clcArr" :key="index"
                    :label="item.CCD_NAME" :value="item.CCD_NAME"></el-option>
                  </el-select>
                </el-form-item>
                <!-- <el-form-item>
                  <el-input v-model="form.name" :class="['circle-input']" placeholder="请输入搜索内容">
                    <i slot="prefix" class="el-input__icon el-icon-search"></i>
                  </el-input>
                </el-form-item> -->
              </div>
              <div class="w50 pl40">
                <el-form-item label="关键词">
                  <el-input v-model="form.word" clearable @change="titleChange($event,'words')" placeholder=""></el-input>
                </el-form-item>
              </div>
               <div class="w50 pl40  pl0">
                <el-form-item label="题名">
                  <el-input v-model="form.title" clearable @change="titleChange($event,'title')" placeholder=""></el-input>
                </el-form-item>
              </div>
              <div class="w50 pl40">
                <el-form-item label="摘要">
                  <el-input v-model="form.abstract" maxlength="50" type="textarea" clearable @change="titleChange($event,'abstract')" placeholder=""></el-input>
                </el-form-item>
              </div>
              <div class="w50 pl40 pl0">
                 <el-form-item label="优先级" prop="type">
                     <el-radio-group v-model="form.radio">
                        <el-radio :label="0">中文论文发文专家</el-radio>
                        <el-radio :label="1">外文论文发文专家</el-radio>
                      </el-radio-group>
                 </el-form-item>
              </div>
              <div class="w50 pl40 label-w70">
                <el-form-item label="年份限制" :class="['input-50']">
                  <el-select v-model="form.yearlimit" placeholder="年份限制">
                    <el-option label="无" :value="0"></el-option>
                    <el-option label="近5年有相关成果" value="5"></el-option>
                    <el-option label="近10年有相关成果" value="10"></el-option>
                  </el-select>
                </el-form-item>
                <div>
                  <el-button type="primary" @click="getPage">检索</el-button>
                </div>
              </div>
           <!-- v-if="tags.length" -->
            <div class="search-text" >
              <div class="search-text-badge  ">
                <span class="el-form-item__label">当前检索词</span>
                <el-tag
                  v-for="(tag,index) in tags"
                  :key="index"
                  v-if="index <= 4"
                  closable
                  :disable-transitions="false"
                  effect="light"
                  @close="delSearch(tag,index)"
                  :type="tag.type">
                  {{tag.name}}
                </el-tag>
                <!-- <el-button @click="delSearch" type="primary">计算机<i class="el-icon-error el-icon--right"></i></el-button> -->
              </div>
              <div>
                <el-form-item  prop="type">
                      <el-radio v-model="form.radio2" :label="0">关键词命中数量优先</el-radio>
                      <el-radio :label="1">关键词高频优先</el-radio>
                     <!-- <el-radio-group >
                        <el-radio v-model="form.radio2" :label="0">关键词命中数量优先</el-radio>
                        <el-radio :label="1">关键词高频优先</el-radio>
                      </el-radio-group> -->
                 </el-form-item>
              </div>
            </div>
             </el-form>
          </div>
          <div class="search-r">
              <div class="menu clearfix">
                <h4
                  v-if="fieldData.total"
                >已经为您检索到{{fieldData.total}}条。</h4>
                <!-- <div class="showway">
                  <span>展示格式</span>
                  <img @click="index=1" src="static/img/icon/nine.png" alt />
                  <img @click="index=2" class="listimg" src="static/img/icon/list.png" alt />
                </div> -->
              </div>
              <div class="res-list clearfix" v-loading="loading2">
                    <div
                      class="exp-box"
                      :style="{width:expWidth}"
                      v-for="( item, index ) in fieldData.data"
                      :key="index"
                    >
                      <div class="exp-box-box">
                        <div class="exp-int clearfix" @click="goDetail(item)">
                          <el-image
                            v-if="item.avatar || item.avatarUrl"
                            class="exp-header"
                            :src="item.avatar?item.avatar:(item.avatarUrl.indexOf('http')>-1?item.avatarUrl:'/old/public'+item.avatarUrl)"
                            fit="contain"
                            
                          >
                            <div slot="placeholder" class="image-slot"    >
                              <img src="http://expert.ckcest.cn/autoload/images/avatar.png" />
                            </div>
                            <div slot="error" class="image-slot"    >
                              <img src="http://expert.ckcest.cn/autoload/images/avatar.png" />
                            </div>
                          </el-image>
                          <el-image
                          
                            v-else
                            class="exp-header"
                            src="http://expert.ckcest.cn/autoload/images/avatar.png"
                            fit="contain"
                          ></el-image>
                          <div class="exp-textint">
                            <h5 >{{item.name}} {{item.honor}}</h5>
                            <p>{{item.organization}}</p>
                            <p>{{/^[0-9]+$/.test(item.kId) ? '已认领' : '未认领'}}</p>
                          </div>
                        </div>
                        <p
                          class="isni"
                          v-if="item.isni"
                        >ISNI：{{item.isni.replace(/(.{4})/g,'$1-').slice(0,item.isni.length+3) }}</p>
                        <p class="isni" v-else></p>
                        <p
                          class="subject"
                          :title="item.subject"
                          v-if="item.subject && item.subject !== ''"
                        >学科：{{item.subject}}</p>
                        <p class="subject" :title="item.subject" v-else></p>
                        <ul
                          class="keywords clearfix"
                          v-if="item.keyword"
                          style="background-color: #f5f5f5;"
                        >
                          <li v-for="li in item.keywordList" :key="li">{{li}}</li>
                        </ul>
                        <ul class="keywords clearfix" v-else></ul>
                      </div>
                    </div>
                    <div style="display:flex;height: 100%; text-align:center;width:100%">
                      <span style="margin:auto;font-size: 20px;" v-if="!fieldData.data.length">暂无关联领域</span>
                    </div>
              </div>
                
            </div>
          <pagination
            :pageSizes="pageSizes"
            :total="fieldData.total"
            :page.sync="pageData.PageIndex"
            :limit.sync="pageData.PageSize"
            :layout="layout"
            @pagination="getPage"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import left from '@/components/commonrRetrieve/left'
import Chart from '@/components/Charts/LineMarker'
import LineMaxMinChart from '@/components/Charts/LineMaxMinChart'
import PieChart from '@/components/Charts/PieChart'
import { getBase64Avatar } from '@/api/center'
import WordcloudChart from '@/components/Charts/WordcloudChart'
import {
  searchCoreKeywordsv2,
  getKeywordTranslate,
  getKeywordAnalysis,clcfind,getKeywordExtract,searchJournalExpert
} from '@/api/retrieveField'
import { search } from '@/api/common'

export default {
  name: 'RetrieveFieldNew',
  props: {},
  watch: {
    index: {
      deep: true,
      handler (val) {
        if (val === 2) {
          this.pageData.PageSize = 3
          this.pageData.PageIndex = this.pageIndex2
          this.pageSizes = [3]
        } else {
          this.pageData.PageSize = 12
          this.pageData.PageIndex = this.pageIndex1
          this.pageSizes = [12]
        }
        this.getPage()
      }
    },
    screenWidth: function (val) {
      this.changeExpWidth(val)
    }
  },
  components: {
    Pagination,
    left,
    Chart,
    LineMaxMinChart,
    PieChart,
    WordcloudChart
  },
  data () {
    return {
      fieldData:{
        data:[]
      }, // 传入的参数
      user: localStorage.getItem('user'), // tid
      keyTr: '', // 关键词翻译
      keyCn: '', // 中文
      isClick: true, // 词云图是否有点击事件
      /* 分页 */
      layout: 'sizes, prev, pager, next, jumper', // 分页
      pageData: {
        PageSize: 12,
        PageIndex: 0
      }, // 分页情况
      pageSizes: [12], // 每页条数

      intercept: false, // 检索到条数文字
      index: 1, //  当前布局
      pageIndex2: 0, // 密集布局当前页面
      pageIndex1: 0, // 当行布局当前页面
      loading1: false, // 加载动画1
      loading2: false, // 加载动画2
      loading3: false, // 加载动画3
      loading4: false, // 加载动画3
      screenData: {}, // 左侧栏返回数据
      keywordList: [], // 关键词数组
      simkeywordsList: [], // 相识关键词数组图表
      acqKeywords: [],
      historyList: [], // 历史热度数组
      // keyEnList: [], // 关键词英文数组（传入左侧栏）
      keyEnCList: [], // 关键词英文数组（Eacher）
      k: '',
      topKeywords: [], // 研究主题
      expWidth: '25%', // 专家信息宽度
      form:{
        CCD_NAME:'',
        word:'',
        radio: 0,
        yearlimit:0,
        radio2:0,
        title:'',
        abstract:''
      },
      clcArr:[],//分类号的数组
      tags: [],
      wordsArr:[],//关键词数组
      titleArr:[],//标题数组
      abstractArr:[],//摘要数组
    }
  },
  mounted () {
    var _this = this
    
  },
  methods: {
    delSearch(item,index){
      console.log('删除')
      this.tags.splice(index,1)
    },
    titleChange(e,type){
      this[type+'Arr'] = []
      // this.tags = [];
      if(!e){
        var tags = this.tags;
        for(let i=tags.length-1; i>=0; i--){
            if(tags[i][type]){
                tags.splice(i,1);
            }
        }
        this.tags = tags;
      }else{
        if(type == 'title' || type == 'abstract'){
          var formData = this.form;
          var obj = {
            title:formData.title,
            abstract:formData.abstract
          }
          getKeywordExtract(obj).then(res => {
            if(res.status == 1){
              res.data.map(item => {
                this.tagsPush(item.word,type)
              })
            }
          })
        }else{
          this.tagsPush(e,type)
        }
      }
      
     
    },
    tagsPush(e,inset){
        var that = this;
        e = e.replace(/;/g,' ').replace(/；/g,' ').replace(/,/g,' ').replace(/，/g,' ')
        e.split(' ').map(item=>{
          var sum = 0
          if(item){
            that.wordsArr.some(el => {
              if(el.name == item){
                sum++;
                return true
              }
            })
            that.titleArr.some(el => {
              if(el.name == item){
                sum++;
                return true
              }
            })
            that.abstractArr.some(el => {
              if(el.name == item){
                sum++;
                return true
              }
            })
            if(!sum){
              var obj = {
                name:item
              }
              obj[inset] = true;
              this[inset+'Arr'].push(obj)
            }
            
          }
        })
        this.tags = [
          ...this.wordsArr,
          ...this.titleArr,
          ...this.abstractArr
        ]
    },
    filterClc(val){
      clcfind({clc:val}).then(res => {
        if(res.status == 1){
          this.clcArr = res.data;
        }
      })
    },
    setAvatar(item){
      return new Promise((resolve) => {
        if(!isNaN(item.kId)){
          getBase64Avatar({kId:item.kId}).then(res => {
            resolve((res.data[0].data[0]&&res.data[0].data[0].avatar)?res.data[0].data[0].avatar.replace(/[\r\n]/g, ""):'')
          })
        }
      })
    },
    getParams(){
        var formData = this.form;
        var keywords = []
        if(this.tags.length){
          this.tags.map(item => {
            keywords.push(item.name)
          })
        }else{
          var arr = [
            ...this.wordsArr,
            ...this.titleArr,
            ...this.abstractArr,
          ]
          arr.map(item => {
            keywords.push(item.name)
          })
        }
        if(keywords.length>5){
          keywords.length = 5;
        }
        return {
          subject:formData.CCD_NAME,//		学科（可选）
          keywords:keywords,//	关键词（数组，可选）
          yearlimit:formData.yearlimit,//	限制发文年份（数字，0无限制；5五年内）
          from:this.pageData.PageIndex,
          size:this.pageData.PageSize
        }
    },
    // 获取新的专家列表数据
    getPage ({...data}) {
      this.pageData.PageIndex = data.page || 1;
      this.pageData.PageSize = data.limit || this.pageData.PageSize;
      this.loading2 = true
      this.getTabel2();
      
    },
    getTabel2(){
      var params = this.getParams()
      params.from = params.from -= 1;
      this.search(params)
    },
    search(params){
      searchJournalExpert(params)
        .then(res => {
          this.loading2 = false
          if(res.status == 1){
            res.data.forEach(async (item, index) => {
                var avatar = ''
                item.keywordList = item.keyword.split(';')
                // await this.setAvatar(item,index).then(res=>{
                //   item.avatar = res
                // })
                res.data[index].avatar = avatar
            })
            this.fieldData = res;
          }
         
        })
        .catch(err => {
          console.log(err)
          this.loading2 = false
        })
    },
    goDetail(item){
      let routeData = this.$router.resolve({
        name: 'Detail',
        query: { kId:item.kId }
      })
      window.open(routeData.href, '_blank')
      // this.$router.push({ name: 'Detail', query: query })
    }
   
  }
}
</script>

<style scoped lang="scss">
.layer{
  .logo{
    margin-top: 10px;
    height: 50px;
    width: auto !important;

  }
}
.retrievalFieldNew {
  padding-top: 20px;
   background: #fff;
   min-height: 500px;
  .center {
    margin-bottom: 20px;
    width: 100%;
    display: block;
    .experts {
      
      padding-bottom: 20px;
      width: 1000px;
      margin: 0 auto;
      
      .search-r {
        width: 100%;
        border-top: 2px solid #000;
        .menu {
          padding: 1em;
          margin-bottom: 15px;
          h4 {
            float: left;
            font-size: 14px;
          }
          .showway {
            float: right;
            span {
              font-size: 12px;
              font-weight: 600;
              vertical-align: text-top;
            }
            img {
              display: inline-block;
              width: 20px;
              height: 20px;
              cursor: pointer;
              margin-left: 5px;
            }
          }
        }
        .res-list {
          display: flex;
          justify-content: flex-start;
          flex-wrap: wrap;
          .exp-box {
            margin-bottom: 15px;
            border: none;
            margin-right: 0;
            padding: 0;
            &-box{
              height: 100%;
              border: 1px #ccc solid;
              padding: 10px;
              margin-right:20px;
              height: 230px;
            }
            .exp-int {
              cursor: pointer;
              display: flex;
              flex-direction: row;
              .exp-header {
                float: left;
                >>>img {
                  display: block;
                  height: 100px;
                  width: 80px;
                }
              }
              .exp-textint {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                margin-left: 10px;
                font-size: 12px;
                h5 {
                  margin-bottom: 10px;
                  cursor: pointer;
                }
                p {
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  margin-bottom: 5px;
                }
              }
            }
            .isni {
              font-size: 12px;
              margin-top: 10px;
              min-height: 20px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .subject {
              min-height: 20px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              font-size: 12px;
            }
            .keywords {
              height: 44px;
              overflow: hidden;
              background-color: #f5f5f5;
              margin-top: 5px;
              li {
                height: 20px;
                float: left;
                border: 1px #ccc solid;
                padding: 1px 2px;
                border-radius: 4px;
                font-size: 12px;
                margin: 0 4px 2px 0;
              }
            }
          }
          //  div.exp-box:nth-child(4n){
          //   .exp-box-box{
          //      margin-right:0px
          //   }
          // }
          // div.exp-box:nth-child(4n+2){
          //   .exp-box-box{
          //      margin: 0 10px;
          //   }
          // }
          // div.exp-box:nth-child(4n+3){
          //   .exp-box-box{
          //      margin:0 10px;
          //   }
          // }
        }
        .res-listelse {
          ul {
            li {
              ::-webkit-scrollbar {
                width: 6px;
                background-color: #f2f2f2;
              }
              ::-webkit-scrollbar-thumb {
                background-color: #dedede;
              }
              height: 240px;
              border: 1px #ccc solid;
              padding: 20px;
              margin-bottom: 10px;
              .eles-info {
                display: flex;
                flex-direction: row;
                .else-header {
                  cursor: pointer;
                  float: left;
                  img {
                    display: block;
                    width: 120px;
                    height: 160px;
                    margin-right: 15px;
                  }
                }
                .else-int {
                  float: left;
                  margin-right: 15px;
                  h5 {
                    font-size: 14px;
                  }
                  p {
                    width: 300px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    font-size: 12px;
                    margin-top: 10px;
                  }
                  .else-keywords {
                    width: 300px;
                    height: 48px;
                    overflow: hidden;
                    margin-top: 10px;
                    span,
                    a {
                      font-size: 12px;
                    }
                    a {
                      height: 20px;
                      margin: 0 5px 4px 0;
                      display: inline-block;
                      border: 1px #ccc solid;
                      padding: 2px 4px;
                      border-radius: 4px;
                    }
                  }
                }
              }
              .else-chart {
                margin-top: 30px;
              }
              .elseinttext {
                float: left;
                width: 60%;
                font-size: 12px;
                overflow: auto;
                height: 200px;
                text-indent: 2em;
                .elseinttext-item {
                  border: none;
                  margin-bottom: 0;
                  height: 200px;
                }
              }
            }
          }
        }
      }
    }
    .institutions {
      margin-top: 20px;

      .institutions-header {
        display: flex;
        align-items: center;
        height: 40px;
        margin-left: 30px;
        img {
          margin-right: 10px;
          width: 20px;
          height: 20px;
        }
      }
      .org-list {
        font-size: 0.85em;
        font-weight: 600;
        .ret-h3 {
          margin: 1em 0;
          margin-left: 30px;
        }
        .res-list {
          margin-top: 20px;
          width: 100%;
          li {
            float: left;
            width: 32%;
            margin-right: 1%;
            margin-bottom: 1%;
            border: 1px #ccc solid;
            padding: 10px;
            .list-t {
              margin-bottom: 15px;
              img {
                float: left;
                width: 100%;
                height: 40%;
              }
              .list-t-r {
                span {
                  &:nth-child(2) {
                    margin-left: 3px;
                  }
                }
              }
            }
            .list-b {
              p {
                float: left;
                margin-top: 10px;
              }
              .list-b-button {
                float: right;
              }
            }
          }
        }
      }
    }
  }
}
</style>
<style  lang="scss">
  .search-form{
    width: 100%;
    button{
      position: relative;
      padding: 15px 20px;
    }
    .srarch-from-inline{
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      width: 100%;
    }
    .el-form-item{
      margin-right: 0;
      display: flex;
      justify-content: flex-start;
      flex-wrap: nowrap;
    }
    .input-50{
        /deep/ .el-form-item__content{
          max-width: calc(100% - 100px);
        }
      }
    .w50{
      display: flex;
      justify-content: center;
      width: 50%;
      margin-bottom: 20px;
    }
    .pl40,.pl0{
      padding-left: 40px;
      .el-form-item{
      .el-form-item__label{
        width: 96px;
      }
      width: 100%;
      .el-form-item__content,.el-select{
        width: calc(100%);
      }
      }
    }
    .pl0{
      padding-left: 0;
    }
    .label-w70{
      .el-form-item__label{
        width: 80px!important;
      }
    }
    .circle-input{
      input{
        border-radius: 30px;
      }
      
    }
  }
  .search-text{
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 1em;
    align-items: center;
    .el-form-item__label{
      font-weight: bold;
    }
    .el-tag{
      padding:0 10px;
      margin: 0 10px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/view/RetrieveFieldNew.vue